window.ErrorHandler = class {
	static async process(error, context = {}) {

		// Si el error no es un error, significa que fue una operacion cancelada, ej promise.reject.
		if(error.isError === false) {
			return;
		}

		if (error.isAxiosError) {

			// Manejo específico para errores de axios
			if (error.code === 'ECONNABORTED') {
				console.error('Error de timeout en solicitud axios:', error.message);
			} else if (error.code === 'ERR_BAD_REQUEST') {
				console.error('Error en la request de axios:', error.message);
			}
			// else if (!error.response) {
			// 	console.error("Error de red en solicitud axios:", error.message);
			// } else {
			// 	console.error("Error en la respuesta de axios:", error.response);
			// }

			// si es error 422 y contiene data de validacion fallida, procesarlos para agregar al DOM.
			if (error.response?.status == 422 && error.response?.data?.validation) {
				this.handleValidationErrors(error.response.data.validation);
			}

			else if (error.response?.data?.phrase || error?.response?.data?.message) {
				await AlertUi.error(error?.response?.data?.phrase || '', error?.response?.data?.message || '');
			}

		}
		else {
			// Loguear el error unicamente cuando no es un error de axios
			this.log(error, context);

			// Mostrar mensaje generico
			await AlertUi.error('ERR_GENERIC_MESSAGE');
		}

	}

	static handleValidationErrors(validationErrors) {
		// Recorremos los errores
		Object.keys(validationErrors).forEach(function(inputName) {
			const rules = validationErrors[inputName];
			let errorMessages = '';

			// Recorremos las reglas fallidas y creamos los mensajes de error (sin el nombre de la regla)
			Object.values(rules).forEach(function(message) {
				errorMessages += `<div>${message}</div>`;
			});

			// Buscamos el input con el name="[inputName]"
			const inputElement = document.querySelector(`input[name="${inputName}"]`);

			if (inputElement) {
				// Verificamos si el input tiene un ID
				let inputId = inputElement.getAttribute('id');

				if (!inputId) {
					// Si no tiene id, le asignamos uno basado en el name del input
					inputId = `input-${inputName}`;
					inputElement.setAttribute('id', inputId);
				}

				// Ahora buscamos el elemento form-label-error con el atributo for="[inputId]"
				let errorLabel = document.querySelector(`.form-label-error[for="${inputId}"]`);

				if (errorLabel) {
					// Si existe, añadimos los mensajes y le agregamos la clase .show
					errorLabel.innerHTML = errorMessages;
					errorLabel.classList.add('show');
				} else {
					// Si no existe, creamos un nuevo div.form-label-error y le asignamos los mensajes y el for
					const newErrorLabel = document.createElement('label');
					newErrorLabel.classList.add('form-label-error');
					newErrorLabel.setAttribute('for', inputId); // Usamos el id del input
					newErrorLabel.innerHTML = errorMessages;

					// Insertamos el nuevo div justo después del input
					inputElement.insertAdjacentElement('afterend', newErrorLabel);

					// Añadimos la clase .show
					newErrorLabel.classList.add('show');
				}
			}
		});
	}

	static log(error, context = {}) {

		// Si el error no es un error, significa que fue una operacion cancelada, ej promise.reject.
		if(error.isError === false) {
			return;
		}

		console.error(error);

		// Captura la excepción en Sentry para análisis posterior
		if(typeof Sentry !== 'undefined') {

			// Si error.context no existe, se inicializa como un objeto vacío
			const existingContext = error.context || {};
			// Merge de context en error.context
			const mergedContext = { ...existingContext, ...context };

			if (mergedContext) {
				Sentry.configureScope(scope => {
					Object.keys(mergedContext).forEach(key => {
						scope.setExtra(key, mergedContext[key]);
					});
				});
			}

			// Capturar el error con Sentry
			Sentry.captureException(error);
		}
	}
}